<ng-container *appLoad="let insight of insight$; trackingName: 'loan-insight'">  
  <app-insight-card [heading]="insight.value + ' Loans'" [change]="insight.change" text="Submitted this month">
  </app-insight-card>
</ng-container>
